(function() {
	'use strict';

	/**
	 * @ngdoc factory
	 * @name dutySheet.factory:DutySheetFactory
	 *
	 * @description
	 *
	 */
	angular.module('dutySheet').factory('DutySheetFactory', DutySheetFactory);

	function DutySheetFactory() {

		// ----declare DTOs------
		function DutySheetSearchRequest() {
			this.fromDateStr = null;
			this.fromTimeStr = null;
			this.toDateStr = null;
			this.toTimeStr = null;
			this.journeyLogNumberStr = null;
			this.crewType = null;
			this.airPortCode = null;
			this.aircraftModel = null;
			this.getOtherGroundDuties = true;
			this.isDestinationOnly = null;
			this.pageSize = 1000;
			this.startPosition = 1;
			this.base = null;
		}

		function DutyDetailDTO() {
			this.patternId = null;
      this.isAllBlocksLegal = null;
      this.dutyBlockDetails = []; // list of DutyBlockDetail
			this.dutyCrewDetails = []; // list of CrewDetail
			this.crewRequired = [];
			this.popOverFlag = null;// list of CrewRequirement
      this.flightHubs = [];
		}

		function CrewDetail() {
			this.checkInTime = null;
			this.contactNumber = null;
			this.coverPilot = null;
			this.crewId = null;
			this.crewName = null;
			this.crewProfileId = null;
			this.crewType = null;
			this.dateOfBirthStr = null;
			this.earlyMin = null;
			this.expiryValidationCodes = null;
			this.gender = null;
			this.languageCode = null;
			this.late = false;
			this.lateMin = null;
			this.legal = true;
			this.obsFlight = null;
			this.passportExpiryDateStr = null;
			this.passportNumber = null;
			this.signOutTimeStr = null;
			this.singInTimeStr = null;
			this.trainee = false;
			this.validationExpiredCrew = false;
			this.duration = null;
			this.isSelect = false;
			this.appCountries =[];
			this.fleetTypes = null;
			this.fdp  = null;
			this.isPIC = null;
			this.crewScheduleBlockId = null;
			this.isDutyChangeAccepted = "Y";
			this.airportRecencyRequired = false;
		}

		function DutyBlockDetail() {
			this.blockId = null;
			this.version = null;
			this.dutyFlightDetails = [];// list of FlightDetail
		}

		function FlightDetail() {
			this.acRegNo = null;
			this.acType = null;
			this.arrivalTimeStr = null;
			this.departureTimeStr = null;
			this.destination = null;
			this.flightLegId = null;
			this.flightNo = null;
			this.lateArrival = false;
			this.lateDeparture = false;
			this.origin = null;
			this.dropt = null;
			this.pickup = null;
			this.depTimeLocalStr = null;
			this.arrTimeLocalStr = null;
			this.flightCanceled = false;
			this.trainee = false;
			this.flightHub = null;
		}

		function CrewRequirement() {
			this.assignedNumber = 0;
			this.defaultRequirement = 0;
			this.typeCode = null;
		}

		function StandByDetailSearchRequest() {
			this.fromDate = null;
			this.toDate = null;
			this.fromTime = null;
			this.toTime = null;
			this.aircraftModel = null;
			this.airport = null;
			this.crewTypeMasterCode = null;
			this.localStartTime = null;
			this.localEndTime = null;
      this.base = null;

		}

		function DeadHeadingSearchRequest() {
			this.fromDateStr = null;
			this.fromTimeStr = null;
			this.toDateStr = null;
			this.toTimeStr = null;
			this.journeyLogNumberStr = null;
			this.crewType = null;
			this.airPortCode = null;
			this.aircraftModel = null;
			this.getOtherGroundDuties = true;
      this.isDestinationOnly = null;
			this.pageSize = 1000;
			this.startPosition = 1;
		}

		function ReadyToWorkSearchRequest() {
			this.fromDate = null;
			this.toDate = null;
			this.pageSize = 1000;
			this.startPosition = 1;
      this.base = null;
		}

    function ReportSickSearchRequest() {
      this.fromDate = null;
      this.toDate = null;
      this.pageSize = 1000;
      this.startPosition = 1;
      this.base = null;
    }

		function OtherDutyTypeDetailSearchRequest() {
			this.fromDateStr = null;
			this.fromTimeStr = null;
			this.toDateStr = null;
			this.toTimeStr = null;
			this.journeyLogNumberStr = null;
			this.crewType = null;
			this.airPortCode = null;
			this.aircraftModel = null;
			this.getOtherGroundDuties = true;
			this.pageSize = 1000;
			this.startPosition = 1;
		}

		function DutySheetSearchCrieteria() {
			this.fromDate = null;
			this.toDate = null;
			this.fromTime = '00:00';
			this.toTime = '23:59';
			this.JourneyLogNo = null;
			this.aircraftType = null;
			this.crewType = null;
			this.airport = null;
			this.isDestinationOnly = false;
		}

		function SendEmailRequest() {
			this.blockIds = [];
			this.baseUrl = null;
		}

		function JourneyLogPrintParam() {
			this.flightDetailList = [];
			this.crewDetailList = [];
		}

		function FlightDetailPrintDTO() {
			/*
			 * pax s/f% s/D A/d F/d remarks
			 */
			this.regNo = null;
			this.flightNO = null;
			this.route = null;
			this.rstdDate = null;
			this.outDate = null;
			this.offDate = null;
			this.arrivalDelay = null;
			this.rstaDate = null;
			this.onDate = null;
			this.inDate = null;
			this.depatureDelay = null;
			this.pax = 0;
			/*
			 * this.actNoAdult; this.actNoChildren; this.actNoInfants;
			 * this.estNoMale; this.estNoFemale; this.estNoChildren;
			 * this.estNoInfants;
			 */
			this.capacity = null;
			this.remarks = null;
			this.flightLegStatus = null;
			this.depatureOperationFlightStatus = null;
			this.arrivalOperationFlightStatus = null;
			this.flightLegId = null;
			this.actionedBy = null;
			this.journyLogId = null;
			this.operationType = null;
			this.airCraftModel = null;
			this.actioneCheckedBY = null;
			this.arrDivActDepDate = null;
			this.arrDivActArrDate = null;
			this.arrDivLandDateTime = null;
			this.arrDivTakeOffDateTime = null;
			this.estDipatureDateTime = null;
			this.origin = null;
			this.destination = null;
			this.estArrivalDateTime = null;
			this.blockVersion = null;
		}

		function CrewDetailPrintDTO() {
			this.staffNo = null;
			this.rank = null;
			this.name = null;
			this.startDateTime = null;
			this.finishDateTime = null;
			this.remarks = null;
			this.signInDateTime = null;
			this.signOutDateTime = null;
			this.isLegal = null;
			this.dateOfBirth = null;
			this.nationalityAbb = null;
			this.unifiedId = null;
			this.passportNo = null;
			this.isObsFlight = null;
			this.gender = null;
			this.blockName = null;
			this.blockStartDateTime = null;
			this.flightNo = null;
			this.lastPositionOccupied = null;
		}

		function DutySheetReport(){
			this.seqNo = null;
			this.acRegNo = null;
			this.acType = null;
			this.arrivalTimeStr = null;
			this.departureTimeStr = null;
			this.destination = null;
			this.flightLegId = null;
			this.flightNo = null;
			this.lateArrival = false;
			this.lateDeparture = false;
			this.origin = null;
			this.dropt = null;
			this.pickup = null;
			this.depTimeLocalStr = null;
			this.arrTimeLocalStr = null;

			this.checkInTime = null;
			this.contactNumber = null;
			this.coverPilot = null;
			this.crewId = null;
			this.crewName = null;
			this.crewProfileId = null;
			this.crewType = null;
			this.dateOfBirthStr = null;
			this.earlyMin = null;
			this.expiryValidationCodes = null;
			this.gender = null;
			this.languageCode = null;
			this.late = false;
			this.lateMin = null;
			this.legal = true;
			this.obsFlight = null;
			this.passportExpiryDateStr = null;
			this.passportNumber = null;
			this.signOutTimeStr = null;
			this.singInTimeStr = null;
			this.trainee = null;
			this.validationExpiredCrew = null;
			this.duration = null;

		}

		function JourneyRequest(){
			this.blockId = null;
			this.version = null;
			this.crewScheduleEventId = null,
			this.isUpdate = true;
		}

		// ----Define Function --------
		function GetDutySheetSearchRequest() {
			return new DutySheetSearchRequest();
		}

		function GetFormattedDutySheetSearchRequest(searchCrieteria) {
			var searchReq = new DutySheetSearchRequest();
			searchReq.fromDateStr = searchCrieteria.fromDate;
			searchReq.fromTimeStr = searchCrieteria.fromTime;
			searchReq.toDateStr = searchCrieteria.toDate;
			searchReq.toTimeStr = searchCrieteria.toTime;
			searchReq.journeyLogNumberStr = searchCrieteria.JourneyLogNo;
			if (!!searchCrieteria.crewType && !!searchCrieteria.crewType.code) {
				searchReq.crewType = searchCrieteria.crewType.code;
			}else if(!!searchCrieteria.crewType){
				searchReq.crewType = searchCrieteria.crewType;
			}
			if (!!searchCrieteria.airport && !!searchCrieteria.airport.airPortCode) {
				searchReq.airPortCode = searchCrieteria.airport.airPortCode;
			}else if(!!searchCrieteria.airport){
				searchReq.airPortCode = searchCrieteria.airport;
			}
			if (!!searchCrieteria.aircraftType && !!searchCrieteria.aircraftType.airCraftType) {
				searchReq.aircraftModel = searchCrieteria.aircraftType.airCraftType;
			}else if(!!searchCrieteria.aircraftType){
				searchReq.aircraftModel = searchCrieteria.aircraftType;
			}
			searchReq.getOtherGroundDuties = true;
			searchReq.isDestinationOnly = searchCrieteria.isDestinationOnly;
      searchReq.base = searchCrieteria.base;
			return searchReq;
		}

		function GetFormattedDutyList(duties) {
			var dutyList = [];
			if (!!duties && duties.length > 0) {
				for (var i = 0; i < duties.length; i++) {
					var dutyDetailDTO = new DutyDetailDTO();
          dutyDetailDTO.isAllBlocksLegal = duties[i].isAllBlocksLegal;
					dutyDetailDTO.dutyBlockDetails = setDutyBlockDetails(duties[i].dutyBlockDetails);
					dutyDetailDTO.dutyCrewDetails = setCrewDetails(duties[i].dutyCrewDetails);
					dutyDetailDTO.flitghRowLenght = !!(dutyDetailDTO.dutyBlockDetails[0].dutyFlightDetails) ?
					dutyDetailDTO.dutyBlockDetails[0].dutyFlightDetails.length:0;
					setEmptyRowsForNotAssignedCrewTypes(duties[i].crewRequired,
							dutyDetailDTO.dutyCrewDetails, dutyDetailDTO);
					dutyDetailDTO.patternId = duties[i].patternId;
					dutyDetailDTO.flightHubs =
					dutyList.push(dutyDetailDTO);
				}
			}
			return dutyList;
		}

		function GetFormattedFlightDuty(duties){
			var dutyList =[];
			var l =0;
			var templ =0;
			angular.forEach(duties, function (duty) {
				if (duty.dutyCrewDetails.length > 0) {
					l++;
					for(var i = 0; i<duty.dutyCrewDetails.length; i++){
					var report = new DutySheetReport();
					report.checkInTime = duty.dutyCrewDetails[i].checkInTime;
					report.contactNumber = duty.dutyCrewDetails[i].contactNumber;
					report.coverPilot = duty.dutyCrewDetails[i].coverPilot;
					report.crewId = duty.dutyCrewDetails[i].crewId;
					report.crewName = duty.dutyCrewDetails[i].crewName;
					report.crewProfileId = duty.dutyCrewDetails[i].crewProfileId;
					report.crewType = duty.dutyCrewDetails[i].crewType;
					report.dateOfBirthStr = duty.dutyCrewDetails[i].dateOfBirthStr;
					report.earlyMin = duty.dutyCrewDetails[i].earlyMin;
					report.expiryValidationCodes = duty.dutyCrewDetails[i].expiryValidationCodes;
					report.gender = duty.dutyCrewDetails[i].gender;
					report.languageCode = duty.dutyCrewDetails[i].languageCode;
					report.late = duty.dutyCrewDetails[i].late;
					report.lateMin = duty.dutyCrewDetails[i].lateMin;
					report.legal = duty.dutyCrewDetails[i].legal;
					report.obsFlight = duty.dutyCrewDetails[i].obsFlight;
					report.passportExpiryDateStr = duty.dutyCrewDetails[i].passportExpiryDateStr;
					report.passportNumber = duty.dutyCrewDetails[i].passportNumber;
					report.signOutTimeStr = duty.dutyCrewDetails[i].signOutTimeStr;
					report.singInTimeStr = duty.dutyCrewDetails[i].singInTimeStr;
					report.trainee = duty.dutyCrewDetails[i].trainee;
					report.validationExpiredCrew = duty.dutyCrewDetails[i].validationExpiredCrew;
					report.havingExpWarnings = duty.dutyCrewDetails[i].havingExpWarnings;
					report.duration = duty.dutyCrewDetails[i].duration;
					report.isPIC = duty.dutyCrewDetails[i].isPIC == 'Y' ? 'PIC' : '';

					if(l!== templ){
					report.seqNo = l;
					}
					templ=l;
						if(duty.dutyBlockDetails[0].dutyFlightDetails.length > i){

							report.acRegNo = duty.dutyBlockDetails[0].dutyFlightDetails[i].acRegNo;
							report.acType = duty.dutyBlockDetails[0].dutyFlightDetails[i].acType;
							report.arrivalTimeStr = duty.dutyBlockDetails[0].dutyFlightDetails[i].arrivalTimeStr;
							report.departureTimeStr = duty.dutyBlockDetails[0].dutyFlightDetails[i].departureTimeStr;
							report.destination = duty.dutyBlockDetails[0].dutyFlightDetails[i].destination;
							report.flightNo = duty.dutyBlockDetails[0].dutyFlightDetails[i].flightNo;
							report.origin = duty.dutyBlockDetails[0].dutyFlightDetails[i].origin;
							report.pickup = duty.dutyBlockDetails[0].dutyFlightDetails[i].pickup+"/"+ duty.dutyBlockDetails[0].dutyFlightDetails[i].dropt;
							report.dropt = duty.dutyBlockDetails[0].dutyFlightDetails[i].dropt;
							report.depTimeLocalStr = duty.dutyBlockDetails[0].dutyFlightDetails[i].depTimeLocalStr;
							report.arrTimeLocalStr = duty.dutyBlockDetails[0].dutyFlightDetails[i].arrTimeLocalStr;

						}
						if(report.crewName === null && report.flightNo === null){
							report = new DutySheetReport();
						}else{
							dutyList.push(report);
						}

					}
				}

			});
			return dutyList;
		}

		function setEmptyRowsForNotAssignedCrewTypes(crewRequirementList,
				crewDetails, dutyDetailDTO) {
			if (!!crewRequirementList && crewRequirementList.length > 0) {
				for (var i = 0; i < crewRequirementList.length; i++) {
					var moreRequired = (crewRequirementList[i].defaultRequirement - crewRequirementList[i].assignedNumber);
					while (moreRequired > 0 && moreRequired != undefined) {
						var crewDetail = new CrewDetail();
						crewDetail.crewType = crewRequirementList[i].typeCode;
						crewDetails.push(crewDetail);
						moreRequired--;
					}
				}
			}
			var emptyRows = setEmptyRowsToShow(dutyDetailDTO);
			for (var i = 0; i < emptyRows; i++) {
				var crewDetail = new CrewDetail();
				crewDetails.push(crewDetail);
			}
		}

		function setEmptyRowsToShow(dutyDetailDTO) {
			var totalNoOfFlights = 0;
			var reqEmptyRows = 0;
			var totalNoOfCrew = dutyDetailDTO.dutyCrewDetails.length;
			for ( var i = 0; i < dutyDetailDTO.dutyBlockDetails.length; i++) {
				totalNoOfFlights += dutyDetailDTO.dutyBlockDetails[i].dutyFlightDetails.length;
			}
			if(totalNoOfFlights > totalNoOfCrew){
				reqEmptyRows = totalNoOfFlights - totalNoOfCrew;
			}
			return reqEmptyRows;
		}

		function setCrewDetails(crewDetailList) {
			var crewDetails = [];
			if (!!crewDetailList && crewDetailList.length > 0) {
				for (var i = 0; i < crewDetailList.length; i++) {
					var crewDetail = new CrewDetail();
					crewDetail.checkInTime = crewDetailList[i].checkInTime;
					crewDetail.contactNumber = crewDetailList[i].contactNumber;
					crewDetail.coverPilot = crewDetailList[i].coverPilot;
					crewDetail.crewId = crewDetailList[i].crewId;
					crewDetail.crewName = crewDetailList[i].crewName;
					crewDetail.crewProfileId = crewDetailList[i].crewProfileId;
					crewDetail.crewType = crewDetailList[i].crewType;
					crewDetail.dateOfBirthStr = crewDetailList[i].dateOfBirthStr;
					crewDetail.earlyMin = crewDetailList[i].earlyMin;
					crewDetail.expiryValidationCodes = getCommaSeperatedStringByList(crewDetailList[i].expiryValidationCodes);
					crewDetail.gender = crewDetailList[i].gender;
					crewDetail.languageCode = crewDetailList[i].languageCode;
					crewDetail.late = crewDetailList[i].late;
					crewDetail.lateMin = crewDetailList[i].lateMin;
					crewDetail.legal = crewDetailList[i].legal;
					crewDetail.obsFlight = crewDetailList[i].obsFlight;
					crewDetail.passportExpiryDateStr = crewDetailList[i].passportExpiryDateStr;
					crewDetail.passportNumber = crewDetailList[i].passportNumber;
					crewDetail.signOutTimeStr = crewDetailList[i].signOutTimeStr;
					crewDetail.singInTimeStr = crewDetailList[i].singInTimeStr;
					crewDetail.trainee = crewDetailList[i].trainee;
					crewDetail.validationExpiredCrew = crewDetailList[i].validationExpiredCrew;
          crewDetail.havingExpWarnings = crewDetailList[i].havingExpWarnings;
					crewDetail.duration = crewDetailList[i].duration;
					crewDetail.appCountries = crewDetailList[i].appCountries;
					crewDetail.fleetTypes = crewDetailList[i].fleetTypes;
					crewDetail.crewIllegalReasons = crewDetailList[i].crewIllegalReasons;
					crewDetail.fdp = crewDetailList[i].fdp;
					crewDetail.isPIC = crewDetailList[i].isPIC == 'Y' ? 'PIC' : '';
					crewDetail.crewScheduleBlockId = crewDetailList[i].crewScheduleBlockId;
					crewDetail.isDutyChangeAccepted = crewDetailList[i].isDutyChangeAccepted;
          crewDetail.sickReportedCrew = crewDetailList[i].sickReportedCrew;
          crewDetail.acmiviolated = crewDetailList[i].acmiviolated;
          crewDetail.airportRecencyRequired = crewDetailList[i].airportRecencyRequired;
					crewDetails.push(crewDetail);
				}
			}
			return crewDetails;
		}

		function getCommaSeperatedStringByList(strList) {
			var str = null;
			if (!!strList && strList.length > 0) {
				str = '';
				for (var i = 0; i < strList.length; i++) {
					str += strList[i] + ',';
				}
				str = str.slice(0, -1);// remove ending comma
			}
			return str;
		}

		function setDutyBlockDetails(dutyBlockDetailList) {
			var dutyBlockDetails = [];
			if (!!dutyBlockDetailList && dutyBlockDetailList.length > 0) {
				for (var i = 0; i < dutyBlockDetailList.length; i++) {
					var dutyBlockDetail = new DutyBlockDetail();
					dutyBlockDetail.blockId = dutyBlockDetailList[i].blockId;
					dutyBlockDetail.version = dutyBlockDetailList[i].version;
					dutyBlockDetail.dutyFlightDetails = setFlightDetails(dutyBlockDetailList[i].dutyFlightDetails);
					setGdPrintTemplates(dutyBlockDetailList[i].dutyFlightDetails, dutyBlockDetail);
					dutyBlockDetails.push(dutyBlockDetail);
				}
			}
			return dutyBlockDetails;
		}

		function setFlightDetails(flightDetailList) {
			var flightDetails = [];
			if (!!flightDetailList && flightDetailList.length > 0) {
				for (var i = 0; i < flightDetailList.length; i++) {
					var flightDetail = new FlightDetail();
					flightDetail.acRegNo = flightDetailList[i].acRegNo;
					flightDetail.acType = flightDetailList[i].acType;
					flightDetail.arrivalTimeStr = flightDetailList[i].arrivalTimeStr;
					flightDetail.departureTimeStr = flightDetailList[i].departureTimeStr;
					flightDetail.destination = flightDetailList[i].destination;
					flightDetail.flightLegId = flightDetailList[i].flightLegId;
					flightDetail.flightNo = flightDetailList[i].flightNo;
					flightDetail.lateArrival = flightDetailList[i].lateArrival;
					flightDetail.lateDeparture = flightDetailList[i].lateDeparture;
					flightDetail.origin = flightDetailList[i].origin;
					flightDetail.dropt = flightDetailList[i].dropt;
					flightDetail.pickup = flightDetailList[i].pickup;
					flightDetail.depTimeLocalStr = flightDetailList[i].depTimeLocalStr;
					flightDetail.arrTimeLocalStr = flightDetailList[i].arrTimeLocalStr;
					flightDetail.flightCanceled = flightDetailList[i].flightCanceled;
					flightDetail.trainee = flightDetailList[i].trainee;
					flightDetail.flightHub = flightDetailList[i].flightHub;
					flightDetails.push(flightDetail);
				}
			}
			return flightDetails;
		}

		function setGdPrintTemplates(flightDetailList, dutyBlockDetail) {
		  var clients = [];
      for (var i = 0; i < flightDetailList.length; i++) {
        clients.push(flightDetailList[i].flightHub);
      }

      dutyBlockDetail.flightHubs = clients;
    }

		// getter and setter of standby search request
		function GetStandByDetailSearchRequest() {
			return new StandByDetailSearchRequest();
		}

		function GetFormattedStandByDetailSearchRequest(searchCrieteria) {
			var standbyDetailReq = new StandByDetailSearchRequest();
			standbyDetailReq.fromDate = searchCrieteria.fromDate;
			standbyDetailReq.fromTime = searchCrieteria.fromTime;
			standbyDetailReq.toDate = searchCrieteria.toDate;
			standbyDetailReq.toTime = searchCrieteria.toTime;
			standbyDetailReq.localStartTime = searchCrieteria.localStartTime;
			standbyDetailReq.localEndTime = searchCrieteria.localEndTime;
      standbyDetailReq.base = searchCrieteria.base;

			if(!!searchCrieteria.crewType && !!searchCrieteria.crewType.code){
				standbyDetailReq.crewTypeMasterCode = searchCrieteria.crewType.code;
			}else if(!!searchCrieteria.crewType){
				standbyDetailReq.crewTypeMasterCode = searchCrieteria.crewType;
			}
			if (!!searchCrieteria.airport && !!searchCrieteria.airport.airPortCode) {
				standbyDetailReq.airport = searchCrieteria.airport.airPortCode;
			}else if(!!searchCrieteria.airport){
			    standbyDetailReq.airport = searchCrieteria.airport;
			}
			if (!!searchCrieteria.aircraftType && !!searchCrieteria.aircraftType.airCraftType) {
				standbyDetailReq.aircraftModel = searchCrieteria.aircraftType.airCraftType;
			}else if(!!searchCrieteria.aircraftType){
				standbyDetailReq.aircraftModel = searchCrieteria.aircraftType;
			}
			return standbyDetailReq;
		}

		// getter and setter of dead heading search request
		function GetDeadHeadingSearchRequest() {
			return new DeadHeadingSearchRequest();
		}

		function GetFormattedDeadHeadingSearchRequest(searchCrieteria) {
			var searchReq = new DeadHeadingSearchRequest();
			searchReq.fromDateStr = searchCrieteria.fromDate;
			searchReq.fromTimeStr = searchCrieteria.fromTime;
			searchReq.toDateStr = searchCrieteria.toDate;
			searchReq.toTimeStr = searchCrieteria.toTime;
			searchReq.journeyLogNumberStr = searchCrieteria.JourneyLogNo;
			if(!!searchCrieteria.crewType && !!searchCrieteria.crewType.code){
				searchReq.crewType = searchCrieteria.crewType.code;
			}else if(!!searchCrieteria.crewType){
				searchReq.crewType = searchCrieteria.crewType;
			}
			if (!!searchCrieteria.airport && !!searchCrieteria.airport.airPortCode) {
			    searchReq.airPortCode = searchCrieteria.airport.airPortCode;
			}else if(!!searchCrieteria.airport){
				searchReq.airPortCode = searchCrieteria.airport;
			}
			if (!!searchCrieteria.aircraftType && !!searchCrieteria.aircraftType.airCraftType) {
				searchReq.aircraftModel = searchCrieteria.aircraftType.airCraftType;
			}else if(!!searchCrieteria.aircraftType){
				searchReq.aircraftModel = searchCrieteria.aircraftType;
			}
			searchReq.getOtherGroundDuties = true;
      searchReq.isDestinationOnly = searchCrieteria.isDestinationOnly;
			return searchReq;
		}

		// getter and setter of ready to work request
		function GetReadyToWorkSearchRequest() {
			return new ReadyToWorkSearchRequest();
		}

    // getter and setter of ready to work request
    function GetReportSickSearchRequest() {
      return new ReportSickSearchRequest();
    }


    function GetFormattedReadyToWorkSearchRequest(searchCrieteria) {
			var readyToWorkReq = new ReadyToWorkSearchRequest();
			readyToWorkReq.fromDate = searchCrieteria.fromDate;
			readyToWorkReq.toDate = searchCrieteria.toDate;
      readyToWorkReq.base = searchCrieteria.base;
			return readyToWorkReq;
		}

    function GetFormattedReportSickSearchRequest(searchCrieteria) {
      var readyToWorkReq = new ReportSickSearchRequest();
      readyToWorkReq.fromDate = searchCrieteria.fromDate;
      readyToWorkReq.toDate = searchCrieteria.toDate;
      readyToWorkReq.base = searchCrieteria.base;
      return readyToWorkReq;
    }

		// getter and setter of other duty type search request
		function GetOtherDutyTypeDetailSearchRequest() {
			return new OtherDutyTypeDetailSearchRequest();
		}

		function GetFormattedOtherDutyTypeDetailSearchRequest(searchCrieteria) {
			var searchReq = new OtherDutyTypeDetailSearchRequest();
			searchReq.fromDateStr = searchCrieteria.fromDate;
			searchReq.fromTimeStr = searchCrieteria.fromTime;
			searchReq.toDateStr = searchCrieteria.toDate;
			searchReq.toTimeStr = searchCrieteria.toTime;
			searchReq.journeyLogNumberStr = searchCrieteria.JourneyLogNo;
			if (!!searchCrieteria.crewType && !!searchCrieteria.crewType.code) {
				searchReq.crewType = searchCrieteria.crewType.code;
			}else if(!!searchCrieteria.crewType){
				searchReq.crewType = searchCrieteria.crewType;
			}
			if (!!searchCrieteria.airport && !!searchCrieteria.airport.airPortCode) {
				searchReq.airPortCode = searchCrieteria.airport.airPortCode;
			}else if(!!searchCrieteria.airport){
				searchReq.airPortCode = searchCrieteria.airport;
			}
			if (!!searchCrieteria.aircraftType && !!searchCrieteria.aircraftType.airCraftType) {
				searchReq.aircraftModel = searchCrieteria.aircraftType.airCraftType;
			}else if(!!searchCrieteria.aircraftType){
				searchReq.aircraftModel = searchCrieteria.aircraftType;
			}
			searchReq.getOtherGroundDuties = true;
			return searchReq;
		}

		function GetSearchCrieteriaObject() {
			return new DutySheetSearchCrieteria();
		}

		function GetFormattedSendEmailRequest(selectedBlockIds) {
			var emailReq = new SendEmailRequest();
			emailReq.blockIds = selectedBlockIds;
			emailReq.baseUrl = window.location.origin;
			return emailReq;
		}

		function GetFormattedJourneyLogPrintParam(selectedDuty) {
			var journeyLogPrintParam = new JourneyLogPrintParam();
			if (!!selectedDuty) {
				journeyLogPrintParam.flightDetailList = getFormattedFlightDetailsByDuty(selectedDuty.dutyBlockDetails);
				journeyLogPrintParam.crewDetailList = getFormattedCrewDetailsByDuty(selectedDuty.dutyCrewDetails);
			}
			return journeyLogPrintParam;
		}

		function getFormattedCrewDetailsByDuty(crewDetails){
			var crewDetailList = [];
			if(!!crewDetails && crewDetails.length>0){
				for(var i=0;i<crewDetails.length;i++){
					if(!!crewDetails[i]){
						crewDetailList.push(getFormattedCrewDetailPrintDTOByFlightDetail(crewDetails[i]));
					}
				}
			}
		}


		function getFormattedCrewDetailPrintDTOByFlightDetail(crewDetail){
			var crewDetailPrintDTO = new CrewDetailPrintDTO();

			crewDetailPrintDTO.staffNo = null;
			crewDetailPrintDTO.rank = null;
			crewDetailPrintDTO.name = crewDetail.crewName;
			crewDetailPrintDTO.startDateTime = null;
			crewDetailPrintDTO.finishDateTime = null;
			crewDetailPrintDTO.remarks = null;
			crewDetailPrintDTO.signInDateTime = crewDetail.singInTimeStr;
			crewDetailPrintDTO.signOutDateTime = crewDetail.signOutTimeStr;
			crewDetailPrintDTO.isLegal = null;
			crewDetailPrintDTO.dateOfBirth = crewDetail.dateOfBirthStr;
			crewDetailPrintDTO.nationalityAbb = null;
			crewDetailPrintDTO.unifiedId = null;
			crewDetailPrintDTO.passportNo = crewDetail.passportNumber;
			crewDetailPrintDTO.isObsFlight = null;
			crewDetailPrintDTO.gender = crewDetail.gender;
			crewDetailPrintDTO.blockName = null;
			crewDetailPrintDTO.blockStartDateTime = null;
			crewDetailPrintDTO.flightNo = null;
			crewDetailPrintDTO.lastPositionOccupied = null;
		}

		function getFormattedFlightDetailsByDuty(dutyBlockDetails) {
			var flightDetails = [];
			if (!!dutyBlockDetails && dutyBlockDetails.length > 0) {
				for (var i = 0; i < dutyBlockDetails.length; i++) {
					if (!!dutyBlockDetails[i].dutyFlightDetails
							&& dutyBlockDetails[i].dutyFlightDetails.length > 0) {
						for (var j = 0; j < dutyBlockDetails[i].dutyFlightDetails.length; j++) {
							if (!!dutyBlockDetails[i].dutyFlightDetails[j]) {
								flightDetails
										.push(getFormattedFlightDetailPrintDTOByFlightDetail(dutyBlockDetails[i].dutyFlightDetails[j]));
							}
						}
					}
				}
			}
			return flightDetails;
		}

		function getFormattedFlightDetailPrintDTOByFlightDetail(
				dutyFlightDetail) {
			var flightDetailPrintDTO = new FlightDetailPrintDTO();
			flightDetailPrintDTO.regNo = dutyFlightDetail.acRegNo;
			flightDetailPrintDTO.flightNO = dutyFlightDetail.flightNo;
			flightDetailPrintDTO.route = dutyFlightDetail.origin +"/"+dutyFlightDetail.destination;
			flightDetailPrintDTO.rstdDate = null;
			flightDetailPrintDTO.outDate = null;
			flightDetailPrintDTO.offDate = null;
			flightDetailPrintDTO.arrivalDelay = null;
			flightDetailPrintDTO.rstaDate = null;
			flightDetailPrintDTO.onDate = null;
			flightDetailPrintDTO.inDate = null;
			flightDetailPrintDTO.depatureDelay = null;
			flightDetailPrintDTO.pax = 0;
			flightDetailPrintDTO.remarks = null;
			flightDetailPrintDTO.flightLegId = dutyFlightDetail.flightLegId;
			flightDetailPrintDTO.airCraftModel = dutyFlightDetail.acType;
			flightDetailPrintDTO.actioneCheckedBY = null;
			flightDetailPrintDTO.estDipatureDateTime = dutyFlightDetail.departureTimeStr;
			flightDetailPrintDTO.origin = dutyFlightDetail.origin;
			flightDetailPrintDTO.destination = dutyFlightDetail.destination;
			flightDetailPrintDTO.estArrivalDateTime = dutyFlightDetail.arrivalTimeStr;
			return flightDetailPrintDTO;
		}

		function GetFormattedJourneyLogPrintParamByDHD(){

		}

		function GetJourneyLogRQ(duty){
			var JourneyRQ = new JourneyRequest();
			JourneyRQ.blockId = duty.dutyBlockDetails[0].blockId;
			JourneyRQ.version = duty.dutyBlockDetails[0].version;
			JourneyRQ.crewScheduleEventId = duty.dutyBlockDetails[0].crewSchEventId;
            return JourneyRQ;
		}

		// map services to return
		return {
			getDutySheetSearchRequest : GetDutySheetSearchRequest,
			getFormattedDutySheetSearchRequest : GetFormattedDutySheetSearchRequest,
			getFormattedDutyList : GetFormattedDutyList,
			getStandByDetailSearchRequest : GetStandByDetailSearchRequest,
			getFormattedStandByDetailSearchRequest : GetFormattedStandByDetailSearchRequest,
			getDeadHeadingSearchRequest : GetDeadHeadingSearchRequest,
			getFormattedDeadHeadingSearchRequest : GetFormattedDeadHeadingSearchRequest,
			getReadyToWorkSearchRequest : GetReadyToWorkSearchRequest,
      getReportSickSearchRequest : GetReportSickSearchRequest,
			getFormattedReadyToWorkSearchRequest : GetFormattedReadyToWorkSearchRequest,
			getFormattedReportSickSearchRequest : GetFormattedReportSickSearchRequest,
			getOtherDutyTypeDetailSearchRequest : GetOtherDutyTypeDetailSearchRequest,
			getFormattedOtherDutyTypeDetailSearchRequest : GetFormattedOtherDutyTypeDetailSearchRequest,
			getSearchCrieteriaObject : GetSearchCrieteriaObject,
			getFormattedSendEmailRequest : GetFormattedSendEmailRequest,
			getFormattedJourneyLogPrintParam : GetFormattedJourneyLogPrintParam,
			getFormattedJourneyLogPrintParamByDHD : GetFormattedJourneyLogPrintParamByDHD,
			getJourneyLogRQ : GetJourneyLogRQ,
			getFormattedFlightDuty :GetFormattedFlightDuty
		}

	}
})();
